import * as IoC from 'typescript-ioc';
import { IApiClient, RequestContentType } from '../../infrastructure/api-client';
import { IEventRequestParams } from '../shared.dto';
import { IAllPagesConfigurationDTO, IEmailAddressDisplayNameDTO, IMeetingLinksLabelDTO, IUpdateShowcaseDTO, IWebsiteDAO } from '../website.dao';
import * as WEBSITE_API from '../../constants/api/website-api.constants';
import { JobDtoType } from '../../domain/jobs';

class WebsiteDAO extends IWebsiteDAO {
    static readonly reservedSubdomainListUrl: string = 'reserved-subdomains';
    static readonly logoUrl: string = 'website/logo';

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getReservedSubDomainArray(): Promise<string[]> {
        const response = await this.apiClient.get<[string]>(WebsiteDAO.reservedSubdomainListUrl);
        return response.parsedResponse;
    }

    public async getAllPagesConfiguration(params): Promise<IAllPagesConfigurationDTO> {
        const response = await this.apiClient.get<IAllPagesConfigurationDTO>(WEBSITE_API.ALL_PAGES, params);
        return response.parsedResponse;
    }

    public async updateAllPagesConfiguration(params: IEventRequestParams, updateParams: IAllPagesConfigurationDTO): Promise<IAllPagesConfigurationDTO> {
        const response = await this.apiClient.put<IAllPagesConfigurationDTO>(WEBSITE_API.ALL_PAGES, {
            ...params,
            ...updateParams
        });
        return response.parsedResponse;
    }

    public async updateWebsiteShowcase(params: IEventRequestParams, showcaseParams: IUpdateShowcaseDTO): Promise<IUpdateShowcaseDTO> {
        const response = await this.apiClient.put<IUpdateShowcaseDTO>(WEBSITE_API.UPDATE_SHOWCASE_URL, {
            ...params,
            ...showcaseParams
        });
        return response.parsedResponse;
    }

    public updateEmailAddressDisplayName = async (params: IEventRequestParams & IEmailAddressDisplayNameDTO): Promise<void> => {
        await this.apiClient.put<IEmailAddressDisplayNameDTO>(WEBSITE_API.EVENTS_EMAIL_DISPLAY_NAME, params);
    };

    public uploadConfigurationJSON = async (params: IEventRequestParams & { file: File }) => {
        const response = await this.apiClient.post<JobDtoType>(WEBSITE_API.CONFIGURATION_JSON_UPLOAD_URL, {
            accountId: params.accountId,
            eventId: params.eventId,
            file: params.file
        }, {
            ContentType: RequestContentType.formData,
        });
        return response.parsedResponse;
    };

    public downloadConfigurationJSON = async (params: IEventRequestParams): Promise<void> => {
        await this.apiClient.getFile(WEBSITE_API.CONFIGURATION_JSON_EXPORT_URL, params);
    };

    public updateMeetingLinksLabel = async (params: IEventRequestParams & IMeetingLinksLabelDTO): Promise<void> => {
        await this.apiClient.put<IMeetingLinksLabelDTO>(WEBSITE_API.MEETING_LINKS_LABEL, params);
    };
}

export { WebsiteDAO };